import { render, staticRenderFns } from "./BeDiscoveredModal.vue?vue&type=template&id=79878d50&scoped=true&"
import script from "./BeDiscoveredModal.vue?vue&type=script&lang=ts&"
export * from "./BeDiscoveredModal.vue?vue&type=script&lang=ts&"
import style0 from "./BeDiscoveredModal.vue?vue&type=style&index=0&id=79878d50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79878d50",
  null
  
)

export default component.exports